import axios from "axios";

const url = process.env.VUE_APP_API_URL;
const type = process.env.VUE_APP_API_TYPE;
const version = process.env.VUE_APP_API_VERSION;

export default axios.create({
	baseURL: `${url}/${type}/${version}/`,
	headers: {
		// "Authorization": "Bearer xxxxx"
	}
});